<template>
  <div class="column-multline" style="font-weight: normal">
    <div class="btns-actions" v-if="consultaNaoConfirmada">
      <confirmar-cancelar-consulta :agenda="row" @success="click"/>
    </div>
  </div>
</template>
<script>
import ConfirmarCancelarConsulta from '@/views/53/components/ConfirmarCancelarConsulta.vue'

export default {
  name: 'AcoesMinhasConsultas',
  components: { ConfirmarCancelarConsulta },
  props: ['column', 'row'],
  computed: {
    consultaNaoConfirmada () {
      return this.row.configuracoes.agendaConfirmada === false && this.row.configuracoes.solicitaConfirmacao
    }
  },
  methods: {
    click () {
      if (this.column && this.column.click) {
        this.column.click(this.row)
      }
      this.$emit('click', this.row)
    }
  }
}
</script>
<style lange="less">
.btns-actions > div{
  display: flex;
  align-items: center;
  :nth-child(1) {
    margin-right: 8px;
  }
}
</style>
